import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cardnumbermodal',
  templateUrl: './cardnumbermodal.component.html',
  styleUrls: ['./cardnumbermodal.component.css']
})
export class CardnumbermodalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
